// extracted by mini-css-extract-plugin
export default {"parentHeader":"chooseRoom_parentHeader__6MXnA","parentRooms":"chooseRoom_parentRooms__veUN1","parentRoomsTitle":"chooseRoom_parentRoomsTitle__MqOVw"};